import { lazyGetChannelReady } from 'owa-notification';
export default function runAfterNotificationSetup(operation) {
    lazyGetChannelReady.import().then(function (getChannelReady) {
        getChannelReady().then(operation);
    });
}
//# sourceMappingURL=runAfterNotificationSetup.js.map